import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@material-ui/core';
import useDate from 'src/hooks/useDate';
import ScopeChoice, { ShiftActionScope } from './ScopeChoice';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onContinue: (scope: ShiftActionScope) => void;
    startTime: string;
    endTime: string;
    date: Date;
    passengerName: string;
    allCount: number;
}

const EditScopeContent: FC<Props> = ({
    isOpen,
    onClose,
    onContinue,
    startTime,
    endTime,
    date,
    passengerName,
    allCount,
}) => {
    const { t } = useTranslation();
    const { fullDays } = useDate();
    // "All" is what the selection asked for; the other choice is one click away
    const [scope, setScope] = useState<ShiftActionScope>('all');

    return (
        <Dialog open={isOpen} onClose={onClose} aria-labelledby="edit-scope-title">
            <div
                dir="rtl"
                style={{ width: 340, padding: '18px 0 12px', display: 'flex', flexDirection: 'column', gap: 12 }}
            >
                <div id="edit-scope-title" style={{ fontSize: 18, fontWeight: 500, padding: '0 16px' }}>
                    {t('editForWhom')} {`${startTime}-${endTime}`}
                    <div style={{ fontSize: 14, fontWeight: 400, color: '#5f6b73', marginTop: 2 }}>
                        {`${t('day')} ${fullDays[moment(date).day()]}, ${moment(date).format('DD.MM')}`}
                    </div>
                </div>
                <ScopeChoice
                    name={t('editForWhom')}
                    value={scope}
                    onChange={setScope}
                    passengerName={passengerName}
                    allCount={allCount}
                />
                <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
                    <Button color="primary" onClick={() => onContinue(scope)}>
                        {t('continueToEdit')}
                    </Button>
                    <Button onClick={onClose} style={{ color: 'gray' }}>
                        {t('cancel')}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

/**
 * Asked before editing a shift of a selected passenger when other selected passengers have the same shift:
 * edit it for this passenger only (as always) or for all of them (customer request, 2026-11-02). Every shift in
 * the grid has one: closed, it runs no hooks at all, and each opening starts again on "all".
 */
const EditScopeModal: FC<Props> = (props) => {
    const { isOpen } = props;
    if (!isOpen) return null;
    return <EditScopeContent {...props} />;
};

export default EditScopeModal;
